import { AuthService } from 'src/app/_services/auth.service';
import jwt_decode from "jwt-decode";
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthParentGuard implements CanActivate {

    constructor(private router: Router,private _authService:AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let acc = JSON.parse(localStorage.getItem('currentUser'));
        var token = localStorage.getItem('token');
       console.log((token)?this._authService.isTokenExpired(token):'')
        
        if (acc && acc.guard == 'PARENT' && !this._authService.isTokenExpired(token)) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/parent/auth'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
